import type { Coin } from "../../services/pulseService";
import { formatPrice, formatPercent, changeColor, formatNumber } from "./utils";

interface Props {
  coins: Coin[];
}

export function CryptoTicker({ coins }: Props) {
  if (!coins.length) {
    return (
      <div className="glass-card p-4 sm:p-5">
        <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3 flex items-center gap-2">
          <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24"><path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z" /></svg>
          Crypto
        </h3>
        <div className="flex items-center justify-center py-6">
          <div className="flex items-center gap-2 text-surface-500 text-xs">
            <div className="h-2 w-2 rounded-full bg-surface-600 animate-pulse" />
            Loading crypto...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="glass-card p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3 flex items-center gap-2">
        <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M11.944 17.97L4.58 13.62 11.943 24l7.37-10.38-7.372 4.35h.003zM12.056 0L4.69 12.223l7.365 4.354 7.365-4.35L12.056 0z" />
        </svg>
        Crypto
      </h3>
      <div className="space-y-1">
        {coins.slice(0, 10).map((coin) => (
          <div
            key={coin.id}
            className="flex items-center justify-between py-2 px-3 rounded-xl hover:bg-surface-800/40 transition-colors"
          >
            <div className="flex items-center gap-2.5 min-w-0">
              <img
                src={coin.image}
                alt={coin.name}
                className="w-6 h-6 rounded-full flex-shrink-0"
                loading="lazy"
              />
              <div className="flex flex-col min-w-0">
                <span className="text-sm font-semibold text-surface-100">
                  {coin.symbol.toUpperCase()}
                </span>
                <span className="text-xs text-surface-500 truncate">{coin.name}</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-sm font-mono font-semibold text-surface-100 tabular-nums">
                ${formatPrice(coin.current_price)}
              </span>
              <span className={`text-xs font-semibold tabular-nums min-w-[55px] text-right ${changeColor(coin.price_change_percentage_24h)}`}>
                {formatPercent(coin.price_change_percentage_24h)}
              </span>
              <span className="text-xs text-surface-500 tabular-nums hidden lg:block min-w-[50px] text-right">
                ${formatNumber(coin.market_cap, 0)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
